import {isDev, isSUT} from './env'

const isOverridable = isSUT() || isDev()

export const isFeatureEnabled = key => {
  const isEnabledByEnv = import.meta.env[key] === 'true'
  const isEnabledByStorage = sessionStorage.getItem(key) === 'true'

  return isOverridable ? isEnabledByStorage || isEnabledByEnv : isEnabledByEnv
}

export const setFeatureFlagOnStorage = (key, value) => {
  sessionStorage.removeItem(key)
  if (!isOverridable) {
    return
  }

  sessionStorage.setItem(key, `${!!value}`)
}

// For flags that are ON by default — returns false only when explicitly 'false'.
// Dev/sut: sessionStorage.setItem('VITE_MODERN_UI_ENABLED', 'false') overrides to legacy.
export const isFeatureEnabledByDefault = key => {
  const isDisabledByEnv = import.meta.env[key] === 'false'
  const isDisabledByStorage = sessionStorage.getItem(key) === 'false'
  return isOverridable ? !(isDisabledByStorage || isDisabledByEnv) : !isDisabledByEnv
}
